<template>
  <el-container>

    <el-header>
      <h2>Espaces de travail</h2>
    </el-header>
    <el-main>
      <el-form class="search-bar" :inline="true" :model="filters" >
        <el-button type="primary" icon="el-icon-fa-plus" @click="addContract" >
          Ajouter
        </el-button>
        <el-form-item label="Nom" >
          <el-input v-model="filters.name" @change="loadPage" />
        </el-form-item>
      </el-form>

      <el-table :data="contracts">
        <el-table-column label="Nom" prop="name" sortable/>
        <el-table-column label="actions" >
          <el-button-group slot-scope="{row}" >
            <el-button
               type="primary"
               icon="el-icon-fa-cog"
               @click="() => editOptions(row)"
               size="small" />
            <el-button
               type="primary"
               icon="el-icon-fa-css3"
               @click="() => editStyle(row)"
               size="small" />
            <el-button
               type="danger"
               icon="el-icon-fa-trash"
               @click="() => remove(row)"
               size="small" />
          </el-button-group>
        </el-table-column>
      </el-table>

      <el-pagination
         layout="prev, pager, next"
         :total="total"
         :background="true"
         :page-size="limit"
         @current-change="handlePageChange" />
    </el-main>

    <el-dialog title="Modifier le Theme" :visible.sync="displayStyleModal" >
      <contract-style
         v-if="currentContract"
         :contract="currentContract"
         @cancel="displayStyleModal = false"
         @save="saveStyle" />
    </el-dialog>

    <el-dialog title="Modifier les options" :visible.sync="displayOptionsModal" >
      <contract-options
         v-if="currentContract"
         :contract="currentContract"
         @cancel="displayOptionsModal = false"
         @save="saveOptions" />
    </el-dialog>
  </el-container>

</template>

<script>
import {api} from 'macarons'
import ContractStyle from './ContractStyle'
import ContractOptions from './ContractOptions'

export default {
  data () {
    return {
      filters: {
        name: null
      },
      contracts: [],
      total: 0,
      limit: 10,
      offset: 0,
      currentContract: null,
      displayStyleModal: false,
      displayOptionsModal: false
    }
  },
  mounted () {
    this.loadPage()
  },
  methods: {
    remove (contract) {
      this.$confirm('Ceci effacera définitivement l\'espace de travail. Continuer ?', 'Attention', {
        confirmButtonText: 'Confirmer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        api.delete('contract/' + contract.id).then(() => this.loadPage())
      })
    },
    addContract () {
      api.put('contract', {
        name: 'nouveau',
        client: 'nouveau',
        code: [...Array(10)].map(i => (~~(Math.random() * 36)).toString(36)).join(''),
        nid: this.total + 1,
        'public': false,
        crisp: false
      }).then(() => {
        this.loadPage()
      })
    },
    handlePageChange (page) {
      this.offset = (page - 1) * this.limit
      this.loadPage()
    },
    loadPage () {
      let url = 'contract?limit=' + this.limit + '&offset=' + this.offset
      if (this.filters.name !== null && this.filters.name !== '') {
        url += '&name=' + this.filters.name
      }
      api.get(url).then(({data}) => {
        this.contracts.splice(0, this.contracts.length, ...data.contracts)
        this.total = data.count
      })
    },
    editStyle (contract) {
      this.currentContract = contract
      this.displayStyleModal = true
    },
    editOptions (contract) {
      this.currentContract = contract
      this.displayOptionsModal = true
    },
    saveStyle (style) {
      this.currentContract.style = style
      this.displayStyleModal = false
      api.patch('contract/' + this.currentContract.id, {style: style}).then(() => {
        this.$store.dispatch('loadTheme')
      }).catch(() => {
        this.$notify.error({
          title: 'Erreur',
          message: 'Le changement de style n\'a pas été sauvegardé correctement'
        })
      })
    },
    saveOptions (options) {
      this.currentContract.hideDefault = options.hideDefault
      this.currentContract.home = options.home
      this.currentContract.crisp = options.crisp
      this.displayOptionsModal = false
      if (this.$store.state.chloe.contract && this.currentContract.id === this.$store.state.chloe.contract.id) {
        this.$store.commit('setContract', this.currentContract)
      }
      api.patch('contract/' + this.currentContract.id, {
        name: options.name,
        crisp: false,
        hideDefault: options.hideDefault,
        home: options.home ? options.home.id : null,
        'public': options['public']
      }).catch(() => {
        this.$notify.error({
          title: 'Erreur',
          message: 'Les modifications n\'ont pas été sauvegardées correctement'
        })
      }).then(this.loadPage)
    }
  },
  components: {
    ContractStyle,
    ContractOptions
  }
}
</script>

<style scoped>
.el-table {
  text-align: left;
}
.search-bar {
    text-align: right;
}
.search-bar >>> .el-form-item__content {
    min-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/contracts/components/Contracts.vue